// «Кто победит?» опросом (HQ-1572): игра выключена сервером — блок who_wins рисуем как опрос болельщиков, без игры.
// Две кнопки команд с эмблемой; после своего голоса, у закрытого опроса и без vote_path — доли percent без кнопок.
// Голос — POST vote_path {team_id}; ответ (options, my_vote…) заменяет блок. sign_in / closed — без кнопок, без тоста.
// Новый who_wins от живого опроса экрана вытесняет локальный ответ на голос (HQ-1699, whoWinsPollModel).
import { useState } from 'react';
import { applyVote, useWhoWinsVote } from '../api/pollQueries';
import type { WhoWinsBlock } from '../api/matchTypes';
import { shownPollBlock, type LocalVote } from './whoWinsPollModel';
import { t } from '../i18n/i18n';
import { haptic } from '../telegram/webapp';
import { Card } from './Card';
import { TeamLogo } from './TeamLogo';
import styles from './WhoWinsPoll.module.css';

export function WhoWinsPoll({ block }: { block: WhoWinsBlock | undefined }) {
  if (!block?.options?.length) return null;
  return <PollCard key={block.fixture_id} block={block} />;
}

function PollCard({ block: initial }: { block: WhoWinsBlock }) {
  const [local, setLocal] = useState<LocalVote | null>(null);
  const block = shownPollBlock(initial, local);
  const [locked, setLocked] = useState(false);
  const vote = useWhoWinsVote(block.vote_path);
  const canVote = Boolean(block.vote_path) && block.open && block.my_vote == null && !locked;
  const send = (teamId: number) => {
    haptic.selection();
    // отказ сети и прочие ошибки — молча, кнопки остаются (можно нажать ещё раз)
    const settle = (result: unknown) => {
      const next = applyVote(block, result);
      setLocal({ base: initial, block: next.block });
      if (next.locked) setLocked(true);
    };
    vote.mutate(teamId, { onSuccess: settle, onError: settle });
  };
  return (
    <Card title={t('tg_who_wins')}>
      <div className={styles.options} data-who-wins={canVote ? 'vote' : 'result'}>
        {block.options.map((o) => {
          const mine = block.my_vote === o.team_id;
          const share = canVote ? null : o.percent;
          const body = <>
            {share != null && <span className={styles.fill} style={{ width: `${share}%` }} aria-hidden="true" />}
            <TeamLogo src={o.team.image} code={o.team.code} size={28} />
            <span className={styles.name}>{o.team.name}</span>
            {share != null && <span className={styles.percent}>{Math.round(share)}%</span>}
          </>;
          // кнопки — только пока голос возможен; иначе строки долей
          return canVote
            ? <button key={o.team_id} className={styles.option} disabled={vote.isPending} onClick={() => send(o.team_id)}>{body}</button>
            : <div key={o.team_id} className={`${styles.option} ${mine ? styles.mine : ''}`} data-mine={mine || undefined}>{body}</div>;
        })}
      </div>
      {block.note && <p className={styles.note}>{block.note}</p>}
    </Card>
  );
}
